import { Step, BookingFlow } from "../../BookingFlow"
import { observable, computed, action, runInAction } from "mobx"
import { BookingDB } from "../../db/BookingLightDB"
import { Booking } from "BookingSystem/db/Booking"

export class PayStep implements Step {
  constructor(db: BookingDB, flow: BookingFlow) {
    this.db = db
    this.flow = flow
  }

  @observable
  flow: BookingFlow

  @observable
  db: BookingDB

  name = "Pay"
  instruction = "Double check your passes"
  help = "Let's finish your order and checkout"

  @observable
  paymentProcessing: boolean = false

  @computed
  get order() {
    return this.flow.currentBooking.currentOrder
  }

  @action.bound
  async charge(cardNonce: string) {
    await this.flow.currentBooking.payCurrentOrder(cardNonce)

    if (this.flow.currentBooking.currentOrder.isComplete)
      setTimeout(() => {
        runInAction(() => {
          this.flow.stepIndex = 0
          this.flow.currentBooking = new Booking(this.db)
        })
      }, 2000)
  }
}
